export default "__VITE_ASSET__Bdz53z5l__"